<template>
  <div id="settings.roles" class="roles">
    <DataTable
      :loading="loading"
      :rows="userStore.customerRoles ?? []"
      :cols-map="{Role: 'name', Permissions: 'permissions'}"
      sortable
      :error-message="errorMessage"
      class="flex-grow-1 w-100 overflow-hidden border"
      @read="readRoles"
    >
      <template #customCells="{row, cols}">
        <template v-for="(col, _) in cols" :key="_">
          <td v-if="col === 'name'">{{ row[col] }}</td>
          <td v-if="col === 'permissions'">
            <div class="d-flex gap-1 flex-wrap">
              <BootstrapBadge v-for="p in row[col]" :key="p.key" variant="secondary">
                {{ p.description || p.key }}
              </BootstrapBadge>
            </div>
          </td>
        </template>
      </template>
    </DataTable>
  </div>
</template>
<script lang="ts" setup>
const loading = ref(true);
const errorMessage = ref('');
const userStore = useUserStore();

const readRoles = async () => {
  loading.value = true;
  try {
    if (userStore.customerRoles !== null) return;
    await userStore.readCustomerRoles();
  } catch (error) {
    errorMessage.value = String(error);
  } finally {
    loading.value = false;
  }
};

onMounted(readRoles);
</script>
<style lang="scss" scoped>
.roles {
  article {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;

    div {
      display: flex;
      flex-wrap: wrap;
      align-items: start;
      gap: 0.5rem;
      width: 100%;
    }

    .role {
      flex-basis: 20rem;
      margin-bottom: 0.5rem;

      span {
        display: block;
        font-size: 0.75rem;
        color: var(--bs-secondary);
      }
    }
  }
}
</style>
